/*
 * R1 Topic Products — format filter chips + result count.
 *
 * Vanilla, no dependencies. Instance-safe: every [data-r1-topic-products]
 * section on the page wires up its own state, so the section can appear more
 * than once.
 *
 * Behavior:
 *   - Chips: filter cards by data-format-group ("all" shows everything).
 *   - Count line: "[shown]/[total]" tokens in the data-label template are
 *     substituted whenever the filter changes.
 *
 * Topic collections are small (≤10 products), so everything renders on one
 * page and filtering is purely client-side show/hide.
 */
(function () {
  function initSection(root) {
    if (root.dataset.r1TopicProductsReady === 'true') return;
    root.dataset.r1TopicProductsReady = 'true';

    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-r1-format-chip]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-r1-product-card]'));
    var countEl = root.querySelector('[data-r1-product-count]');

    var activeGroup = 'all';

    function apply() {
      var shown = 0;

      cards.forEach(function (card) {
        var group = card.getAttribute('data-format-group') || '';
        var visible = activeGroup === 'all' || group === activeGroup;

        card.classList.toggle('is-hidden', !visible);
        if (visible) shown++;
      });

      updateCount(shown);
    }

    function updateCount(shown) {
      if (!countEl) return;
      var total = parseInt(countEl.getAttribute('data-total'), 10) || cards.length;
      var text = (countEl.getAttribute('data-label') || '')
        .replace('[shown]', shown)
        .replace('[total]', total);
      countEl.textContent = text;
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        activeGroup = chip.getAttribute('data-format-group') || 'all';
        chips.forEach(function (c) {
          c.classList.toggle('is-active', c === chip);
        });
        apply();
      });
    });
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-r1-topic-products]');
    Array.prototype.forEach.call(sections, initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when the theme editor injects/updates this section.
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-r1-topic-products]');
    if (section) initSection(section);
  });
})();
